import React from "react";

const fmt = (val) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(Math.abs(val));

const Stat = ({ label, value, sub, color = "text-[#111827]" }) => (
  <div className="flex items-baseline gap-1.5 min-w-0">
    <span className="text-[10.2px] font-semibold  uppercase tracking-wide whitespace-nowrap">
      {label}:
    </span>
    <span className={`text-sm font-semibold whitespace-nowrap ${color}`}>
      {value}
    </span>
    {sub && (
      <span className="text-[10px] text-[#9ca3af] whitespace-nowrap">{sub}</span>
    )}
  </div>
);

const Divider = () => <div className="w-px h-5 bg-[#e5e7eb] shrink-0 self-center" />;

const RepriceSummaryBar = ({ summary }) => {
  if (!summary) return null;

  const { up, down, net } = summary;

  const upCountPct =
    (net?.count ?? 0) > 0
      ? Math.round(((up?.count ?? 0) / net.count) * 100)
      : 0;
  const downCountPct =
    (net?.count ?? 0) > 0
      ? Math.round(((down?.count ?? 0) / net.count) * 100)
      : 0;

  const netValue = net?.value ?? 0;
  const netRapAvg = net?.rap_avg ?? 0;

  return (
    <div className="w-full flex items-center justify-center gap-2 px-[1.5rem] py-[0.6rem] bg-white border-l-0 border-t-0 border-b border-solid border-[#EBEBEB] sticky top-[50px] z-[99]">

     <div className="flex items-center gap-2 px-[0.7rem] py-[0.5rem] border-solid border-1 border-[#79bff1] rounded-lg ">
      <Stat
        label="Price Decreased"
        value={`${down?.count ?? 0} Stones`}
        sub={`(${downCountPct}% of repriced)`}
        color="text-[#b91c1c]"
      />

      <Divider />

      <Stat
        label="Price Increased"
        value={`${up?.count ?? 0} Stones`}
        sub={`(${upCountPct}% of repriced)`}
        color="text-[#15803d]"
      />

      <Divider />

      <Stat
        label="Total Decrease"
        value={`-${fmt(down?.value ?? 0)}`}
        color="text-[#b91c1c]"
      />

      <Divider />

      <Stat
        label="Total Increase"
        value={`+${fmt(up?.value ?? 0)}`}
        color="text-[#15803d]"
      />

      <Divider />

      <Stat
        label="Net Impact"
        value={`${netValue >= 0 ? "+" : "-"}${fmt(netValue)}`}
        color={netValue >= 0 ? "text-[#15803d]" : "text-[#b91c1c]"}
      />

      <Divider />

      <Stat
        label="Net Rap Change"
        value={`${netRapAvg >= 0 ? "+" : ""}${netRapAvg.toFixed(2)}`}
        color={netRapAvg >= 0 ? "text-[#15803d]" : "text-[#b91c1c]"}
      />
     </div>
    </div>
  );
};

export default RepriceSummaryBar;
